module.exports = __webpack_public_path__ + "static/media/7.43937e7c.jpeg";